import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import styled from '@emotion/styled'

import { selectUserNearestStore, selectStorePinUrl } from '../../../../flux/selectors/stores'
import { selectHasStores, selectIsCampaignExpired } from '../../../../flux/selectors/ux'
import { uxEvent } from '../../../../flux/actions/ux'

import LinkToNearestStore from '../../Links/LinkToNearestStore'
import LoadingSkeleton from '../../Generics/LoadingSkeleton'

import Map from '../../Maps/index'

const StyledRoot = styled.div(({ theme: { spaces, breakpoints } }) => ({
  width: '100%',
  height: '138px',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  marginBottom: spaces.default / 2,
  [`@media (min-width: ${breakpoints.medium})`]: {
    height: '150px',
  },
}))

const StyledContainer = styled.div(({ theme: { breakpoints } }) => ({
  width: '100%',
  height: '100%',
  maxWidth: breakpoints.xlarge,
}))

const NearestStoreMap = ({
  lat,
  lng,
  pinSrc,
  hasStores,
  onNearestStoreMapClick,
}) => {
  const markers = useMemo(() => ([{ lat, lng, pin: pinSrc }]), [lat, lng, pinSrc])
  if (!hasStores) return null
  if (lat && lng) {
    return (
      <StyledRoot data-test="NearestStoreMap" onClick={onNearestStoreMapClick}>
        <StyledContainer>
          <LinkToNearestStore>
            <Map dynamic={false} markers={markers} />
          </LinkToNearestStore>
        </StyledContainer>
      </StyledRoot>
    )
  }
  if (lat === undefined && lng === undefined) {
    return (
      <StyledRoot data-test="NearestStoreMap" onClick={onNearestStoreMapClick}>
        <StyledContainer>
          <LoadingSkeleton />
        </StyledContainer>
      </StyledRoot>
    )
  }
  return null
}

NearestStoreMap.propTypes = {
  lat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  lng: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  pinSrc: PropTypes.string,
  hasStores: PropTypes.bool,
  onNearestStoreMapClick: PropTypes.func.isRequired,
}

NearestStoreMap.defaultProps = {
  pinSrc: null,
  lat: undefined,
  lng: undefined,
  hasStores: false,
}

const mapStateToProps = state => {
  const hasStores = selectHasStores(state)
  const store = selectUserNearestStore(state)
  const isCampaignExpired = selectIsCampaignExpired(state)
  const pinSrc = store?.id ? selectStorePinUrl(store.id)(state) : ''
  let lat
  let lng
  if (typeof isCampaignExpired === 'boolean') {
    lat = store ? store.lat : null
    lng = store ? store.lng : null
  }
  return {
    lat,
    lng,
    pinSrc,
    hasStores,
  }
}

const mapDispatchToProps = dispatch => ({
  onNearestStoreMapClick: () => {
    dispatch(uxEvent({
      name: 'click',
      target: 'NearestStoreMap',
      params: { },
    }))
  },
})

NearestStoreMap.displayName = 'NearestStoreMap'
NearestStoreMap.whyDidYouRender = true

export default connect(mapStateToProps, mapDispatchToProps)(
  React.memo(NearestStoreMap),
)
